
<div class="val-vue-dashboard">

	<div class="val-vue-dashboard-filtre">
		<val-dashboard-filtre-temporel (filtreChange)="OnFiltreChange($event)">
		</val-dashboard-filtre-temporel>
	</div>

	<div class="val-vue-dashboard-contenu">

		@if (zoneVentesVisible) {
			<div class="val-vue-dashboard-zone" id="zone-ventes">
				<div class="val-vue-dashboard-zone-entete">
					<span class="val-vue-dashboard-zone-titre">{{ 'dashboard.zone-ventes.titre' | transloco }}</span>
					<div class="val-vue-dashboard-zone-separateur"></div>
				</div>
				<div class="val-vue-dashboard-zone-grille">
					<val-carte-factures-transmises [filtrePeriode]="filtrePeriodeSelectionne"></val-carte-factures-transmises>
					<val-carte-suivi-regularisations-vente [filtrePeriode]="filtrePeriodeSelectionne"></val-carte-suivi-regularisations-vente>
					<val-carte-repartition-statuts-vente [filtrePeriode]="filtrePeriodeSelectionne"></val-carte-repartition-statuts-vente>
					<val-carte-podium-motifs-retours [filtrePeriode]="filtrePeriodeSelectionne"></val-carte-podium-motifs-retours>
				</div>
			</div>
		}

		@if (zoneAchatsVisible) {
			<div class="val-vue-dashboard-zone" id="zone-achats">
				<div class="val-vue-dashboard-zone-entete">
					<span class="val-vue-dashboard-zone-titre">{{ 'dashboard.zone-achats.titre' | transloco }}</span>
					<div class="val-vue-dashboard-zone-separateur"></div>
				</div>
				<div class="val-vue-dashboard-zone-grille">
					<val-carte-factures-recues [filtrePeriode]="filtrePeriodeSelectionne"></val-carte-factures-recues>
					<val-carte-suivi-regularisations-achat [filtrePeriode]="filtrePeriodeSelectionne"></val-carte-suivi-regularisations-achat>
					<val-carte-repartition-statuts-achat [filtrePeriode]="filtrePeriodeSelectionne"></val-carte-repartition-statuts-achat>
				</div>
			</div>
		}

	</div>

</div>

<val-dashboard-navigation [zones]="zonesVisibles"></val-dashboard-navigation>
